import { render, staticRenderFns } from "./TableMultiline.vue?vue&type=template&id=62b85ee0&scoped=true&"
import script from "./TableMultiline.vue?vue&type=script&lang=js&"
export * from "./TableMultiline.vue?vue&type=script&lang=js&"
import style0 from "./TableMultiline.vue?vue&type=style&index=0&id=62b85ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b85ee0",
  null
  
)

export default component.exports